import { PaginatedSumResults } from "admin/src/server/mappers/Pagination";
import {
  InvoiceLiteView,
  InvoiceView,
} from "admin/src/server/mappers/invoice/invoice";
import { ApiResponse } from "admin/src/ui/types/common/api-response";
import { ApiMutationConfig, ApiQueryConfig } from "api";
import { NewInvoice } from "types/Invoice";

const GetInvoices: ApiQueryConfig<
  ApiResponse<PaginatedSumResults<InvoiceLiteView>>,
  {
    societyId: string;
    profileId: string;
  },
  {
    status?: string[];
    productType?: number[];
  }
> = {
  queryKey: {
    baseQueryKey: ["GetInvoices"],
    dynamicQueryKey: ["status", "productType", "profileId"],
  },
  apiPath: "/api/v1/society/{societyId}/profiles/{profileId}/invoices",
};

const CreateInvoice: ApiMutationConfig<
  ApiResponse<InvoiceView>,
  { societyId: string; profileId: string },
  NewInvoice
> = {
  apiPath: "api/v1/society/{societyId}/accounting/invoices/{profileId}/new",
  method: "POST",
  invalidates: [{ baseQueryKey: GetInvoices.queryKey.baseQueryKey }],
};

export { CreateInvoice, GetInvoices };
